import {
  Flex,
  Icon,
  Text,
  useColorMode,
  useColorStyle,
} from '@tonic-one/react';
import { InfoIcon } from '@tonic-one/react-icons';
import { useTranslation } from 'react-i18next';

const Note = ({ content }: { content: string }) => {
  const [colorMode] = useColorMode();
  const [colorStyle] = useColorStyle({ colorMode });
  const { t } = useTranslation('common');
  return (
    <Flex align="top" gap="8px">
      <Icon as={InfoIcon} color={colorStyle.color.info} />
      <Text fontWeight="semibold" flex="none">
        {t('common.label.note')}:
      </Text>
      <Text color={colorStyle.color.secondary}>{content}</Text>
    </Flex>
  );
};

export default Note;
